import React, { FC, useCallback, useMemo } from 'react';
import { useField } from 'formik';
import { FormField, Label, Combobox, FormHelp } from '@zillow/constellation';
import { useListLendersQuery } from 'API/lenders/LenderCompanyApi';

const useGetLenders = () => {
  const { data: lenders = [] } = useListLendersQuery({ includeDeactivated: false });

  return useMemo(
    () =>
      lenders.map((lender) => ({
        label: lender.name,
        value: lender.id,
        id: lender.id,
      })),
    [lenders]
  );
};

export const LenderCompaniesFilter: FC = () => {
  const [field, meta, helpers] = useField<string[]>({ name: 'lenderCompanyIds' });
  const lenderOptions = useGetLenders();

  const onChange = useCallback(
    (nextValue: any) => {
      helpers.setValue(nextValue);
    },
    [helpers]
  );

  return (
    <FormField
      label={<Label>Lenders</Label>}
      control={
        <Combobox
          value={field.value}
          options={lenderOptions}
          onChange={onChange}
          autoCompleteBehavior="automatic"
          multiple
          showLabelForValue
          limitTagsShown={1}
        />
      }
      error={!!meta.error}
      description={<FormHelp>{meta.error}</FormHelp>}
    />
  );
};
